import React from 'react';
import styled from 'styled-components';
import Colours from '@shared/ui/atoms/Colours';

export type CheckinIpAddressStatus = 'PENDING' | 'APPROVED' | 'REJECTED';

export function CheckinIpStatusPill(props: { status: CheckinIpAddressStatus }) {
  switch (props.status) {
    case 'APPROVED': return <StatusPill $variant="ok">Approved</StatusPill>;
    case 'PENDING': return <StatusPill $variant="pending">Pending approval</StatusPill>;
    case 'REJECTED': return <StatusPill $variant="danger">Not approved</StatusPill>;
  }
}

export const IpValue = styled.span`
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 14px;
  font-weight: 600;
`

const StatusPill = styled.span<{ $variant: 'ok' | 'pending' | 'danger' }>`
  font-family: proxima-nova;
  font-size: 12px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 999px;
  white-space: nowrap;
  background: ${p => p.$variant === 'ok' ? Colours.green : (p.$variant === 'danger' ? Colours.red : Colours.orange20)};
  color: ${p => p.$variant === 'pending' ? Colours.darkGrey : 'white'};
`
